import { createFileRoute } from "@tanstack/react-router";
import UkHelp from "@/pages/help/UkHelp";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/fr/help/")({
  head: () => routeHead("/fr/help/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UkHelp />
  );
}
